<form [formGroup]="form" (ngSubmit)="createCargo()" class="create-cargo__form py-4 px-2 px-sm-3 px-md-5 w-100">
    <div class="row">
        <h3 class="col-12 my-3 text-bold">Creación Solicitud Servicio de Transporte</h3>
        <div class="col-12 mt-3" permission-display [module]="permission.cargo.module"
            [functionality]="permission.cargo.changeManifestRequirement">
            <label class="text-strong mr-3">Requiere manifiesto de carga</label>
            <mat-button-toggle-group #group="matButtonToggleGroup" formControlName="ministry">
                <mat-button-toggle [value]="true">
                    Si
                </mat-button-toggle>
                <mat-button-toggle [value]="false">
                    No
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <p class="col-12 my-3">
            <span class="text-bold">Contratante del servicio</span> (Propietario del servicio / Generador del servicio /
            Contratante)
        </p>
        <app-select-company class="col-md-6" [options]="optionsCompany" [inputFormControl]="companyControl"
            [validate]="formValidate">
        </app-select-company>
        <app-select-transport-company class="col-md-6" *ngIf="hasTransportServicesCompany && companyControl.value"
            [inputFormControl]="transportCompanyControl" [options]="{
                appearance: 'outline',
                enforceChangePermission: true
            }">
        </app-select-transport-company>
        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>
                    Código de identificador cliente
                    <span class="optional">(opcional)</span>
                </mat-label>
                <input matInput type="text" formControlName="doc">
            </mat-form-field>
        </div>

        <p class="col-12 my-3 text-bold">
            Origen
        </p>
        <app-autocomplete-city [inputFormControl]="form.get('origin')" class="col-md-6" [options]="originCityOptions"
            [validate]="formValidate">
        </app-autocomplete-city>
        <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Fecha de cargue estimada<span class="asterisk">*</span></mat-label>
            <input matInput [min]="loadDateOptions.min" [matDatepicker]="pickerLoadDate" formControlName="dateLoad"
                [max]="loadDateOptions.max" name="loadDate" (click)="pickerLoadDate.open()"
                (dateChange)="updateDestinationDates()" readonly>
            <mat-datepicker-toggle matSuffix [for]="pickerLoadDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerLoadDate></mat-datepicker>
            <mat-error *ngIf="form.get('dateLoad').errors?.required">
                {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
        </mat-form-field>

        <div class="col-12 d-flex flex-wrap p-0" *ngFor="let destination of destinations?.controls; let i = index">
            <label class="col-12 d-flex justify-content-between align-items-center">
                <p class="mb-0 text-bold">Destino {{i+1}}</p>
                <i matTooltip="Eliminar destino" class="fas fa-times-circle cursor-pointer" *ngIf="!!i"
                    (click)="deleteDestination(i)"></i>
            </label>
            <app-autocomplete-city [inputFormControl]="destination.get('destination')" class="col-md-6"
                [options]="destinationCityOptions" [validate]="formValidate">
            </app-autocomplete-city>

            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Fecha de descargue estimada<span class="optional">(opcional)</span></mat-label>
                <input matInput [min]="endDateOptions[i].min" [max]="loadDateOptions.max"
                    [matDatepicker]="pickerEndDate" [formControl]="destination.get('downloadDate')" name="endDate"
                    (click)="pickerEndDate.open()" (dateChange)="updateDestinationDates()" readonly>
                <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerEndDate></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="font-secondary-dark text-bold col-12 mb-3">
            <span (click)="addDestination()" class="cursor-pointer">
                <i class="fas fa-plus-circle mr-2"></i>
                Agregar otro destino
            </span>
        </div>

        <p class="col-12 my-3 text-bold">
            Tipo de viaje y etiquetas
        </p>

        <mat-form-field appearance="outline" class="col-md-6 mb-1">
            <mat-label>Tipo de viaje<span class="asterisk">*</span></mat-label>
            <mat-select formControlName="tripType">
                <mat-option *ngFor="let type of tripTypesEnabled" [value]="type.value">
                    {{ type.label }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('tripType').errors?.required">
                {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6" appearance="outline">
            <mat-label>Seleccionar etiqueta<span class="optional">(opcional)</span></mat-label>
            <mat-select [formControl]="tagControl" (selectionChange)="selectTag($event)">
                <mat-option *ngFor="let tag of tags" [value]="tag.name"
                    [disabled]="form.get('labels')?.value?.includes(tag.name)">
                    {{tag.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="col-md-6 col-xl-4" *ngFor="let tag of form.get('labels')?.value; let i = index">
            <div class="tag-card">
                <p class="text-bold">{{tag}}</p>
                <i class="fas fa-times cursor-pointer" (click)="clearTag(i)"></i>
            </div>
        </div>

        <p class="col-12 my-3 text-bold">
            Vehículo
        </p>
        <div class="d-flex flex-wrap col-12 p-0">
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Cantidad de vehículos<span class="asterisk">*</span></mat-label>
                <input matInput type="text" onlyNumbersInt formControlName="quantity">
                <mat-error *ngIf="form.get('quantity').errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
                <mat-error *ngIf="form.get('quantity').errors?.min">
                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'cantidad de vehículos', 1) }}
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Alias del vehículo<span class="optional">(opcional)</span></mat-label>
                <mat-select [formControl]="vehicleAliasControl" (selectionChange)="selectVehicleAlias($event)">
                    <mat-option *ngFor="let alias of vehicleAliases" [value]="alias">
                        {{alias?.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="d-flex flex-wrap col-12 p-0">
            <app-type-vehicle [inputFormControl]="vehicleTypeControl" [options]="optionsTypeVehicle" class="col-md-4"
                [validate]="formValidate"></app-type-vehicle>
            <mat-form-field appearance="outline" class="col-md-4" *ngIf="showAxlesControl">
                <mat-label>Número de ejes<span class="asterisk">*</span></mat-label>
                <input matInput type="text" onlyNumbersInt [formControl]="vehicleAxlesControl" [min]="2"
                    (change)="updateVehicleAxles($event)">
                <mat-error *ngIf="vehicleAxlesControl.errors?.min">
                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'número de ejes', 2) }}
                </mat-error>
                <mat-error *ngIf="vehicleAxlesControl.errors?.required">
                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                </mat-error>
            </mat-form-field>
            <app-vehicle-body-work-type [inputFormControl]="bodyworkTypeControl" [options]="optionsBodyworkType"
                class="col-md-4" *ngIf="vehicleTypeControl?.value?.name">
            </app-vehicle-body-work-type>
        </div>
        <div class="d-flex flex-wrap col-12 p-0" *ngIf="showTrailerInfo">
            <app-vehicle-body-work-type [inputFormControl]="trailerBodyworkControl" [options]="{
                title: 'Tipo de carrocería del tráiler',
                initialVehicleTypeId: '41'
            }" class="col-md-6">
            </app-vehicle-body-work-type>
            <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Número de ejes del tráiler<span class="optional">(opcional)</span></mat-label>
                <input matInput type="text" onlyNumbersInt [formControl]="trailerAxlesControl" [min]="2">
                <mat-error *ngIf="trailerAxlesControl.errors?.min">
                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'número de ejes del tráiler', 2) }}
                </mat-error>
            </mat-form-field>
        </div>
        <p class="col-12 my-3 text-bold">
            Dimensiones del servicio
        </p>

        <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Peso total de la mercancía<span class="optional">(opcional)</span></mat-label>
            <input matInput type="text" onlyNumbersInt formControlName="weight">
            <mat-error *ngIf="form.get('weight').errors?.min">
                {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'peso', 1) }}
            </mat-error>
            <mat-error *ngIf="form.get('weight').errors?.max">
                {{ utils.giveMessageError('MAX_VALUE_EXCEED', 'peso', maxWeightAllowed) }}
            </mat-error>
        </mat-form-field>

        <div class="col-md-6">
            <mat-label class="text-bold">Unidad de medida</mat-label>
            <mat-radio-group aria-label="Select an option" formControlName="unit">
                <mat-radio-button [value]="'1'">Kilos</mat-radio-button>
                <mat-radio-button [value]="'2'">Galones</mat-radio-button>
            </mat-radio-group>
        </div>

        <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Volumen en m³<span class="optional">(opcional)</span></mat-label>
            <input matInput type="text" onlyNumbersDouble formControlName="measurements">
            <mat-error *ngIf="form.get('measurements').errors?.min">
                {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'volumen', 0.0001) }}
            </mat-error>
        </mat-form-field>

        <u class="col-md-6 align-self-center color-primary cursor-pointer" (click)="openDialogCalculatorMeasurements()">
            Calcular cubicaje
        </u>

        <div class="d-flex flex-wrap col-12 p-0">
            <div class="col-md-6">
                <p class="my-3 text-bold">
                    Flete
                </p>
                <mat-form-field appearance="outline">
                    <mat-label>
                        Valor del flete
                        <span class="optional">(Valor a pagar al conductor)</span>
                        <span class="asterisk">*</span>
                    </mat-label>
                    <input matInput type="text" currencyMask min="0" placeholder="$000.000"
                        [formControl]="form.get('cost')">
                    <mat-error *ngIf="form.get('cost').errors?.min">
                        {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'flete', minCost) }}
                    </mat-error>
                    <mat-error *ngIf="form.get('cost').errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="col-md-12 mt-3">
            <p class="text-bold mb-3">Observaciones internas</p>
            <mat-form-field appearance="outline">
                <mat-label>Notas adicionales<span class="optional">(opcional)</span></mat-label>
                <input matInput type="text" formControlName="observation">
            </mat-form-field>
        </div>

        <div class="col-md-12 mt-3">
            <p class="text-bold mb-3">Requisitos adicionales para el conductor</p>
            <mat-form-field appearance="outline">
                <mat-label>Notas adicionales<span class="optional">(opcional)</span></mat-label>
                <input matInput type="text" formControlName="observationDriver">
            </mat-form-field>
        </div>
        <div class="col-md-12 mt-3">
            <b class="text-bold">Publicación</b>
        </div>
        <div class="col-md-12">
            <mat-radio-group formControlName="zone" class="flex-column">
                <mat-radio-button value="private"><span class="zone-radio-button">
                        <b>Privada:</b> Visible solo para los conductores
                        directamente asociados a mi compañía.
                    </span></mat-radio-button>
                <mat-radio-button value="public"><span class="zone-radio-button">
                        <b>Pública:</b> Visible para todos los
                        conductores de la comunidad LoggiApp.
                    </span></mat-radio-button>
                <mat-radio-button value="reserved"><span class="zone-radio-button">
                        <b>Reservada:</b> Reservada para la asignación de un conductor
                        que está confirmado que tomará el servicio.
                    </span></mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="col-md-3 offset-md-9">
            <button mat-raised-button color="accent" class="w-100" type="submit"
                [ngClass]="{'bg-color-primary':isEnableToCreateCargo, 'disabled-btn':!isEnableToCreateCargo}">Crear</button>
        </div>
    </div>
</form>
